<div class="p-mr-2 p-mb-2" *ngIf="showOCRButton">
    <a class="btn btn-tertiary text-center" (click)="showQueryDialog()">{{
        "Common.Button.OCR" | translate
        }}</a>
</div>

<p-dialog *ngIf="isDialogMode" [(visible)]="isShowQueryDialog" [modal]="true" [draggable]="false"
    closeIcon="pi pi-close" styleClass="p-dialog-lg" appendTo="body" [contentStyle]="{ overflow: 'scroll' }"
    (onHide)="CancelDialog()">
    <!--todo-->
    <ng-template pTemplate="header">
        <h1>
            {{ "Common.Button.OCR" | translate }}
        </h1>
    </ng-template>
    <div class="cfc-list cfc-max-height-600">
        <ul class="cfc-list-wrapper">
            <li class="cfc-list-item" *ngFor="let record of oCRRecords">
                <ng-container [ngSwitch]="record.name">
                    <ng-template [ngSwitchCase]="'IDcard'">
                        <div class="p-field-label">
                            <label>
                                <small class="p-text-red p-required" *ngIf="submissionOCRICCardRequired">*</small>
                                {{ record.title | translate }}
                            </label>
                        </div>
                    </ng-template>
                    <ng-template [ngSwitchCase]="'PaySlip'">
                        <div class="p-field-label">
                            <label>
                                <small class="p-text-red p-required" *ngIf="submissionOCRPaySlipRequired">*</small>
                                {{ record.title | translate }}
                            </label>
                        </div>
                    </ng-template>
                </ng-container>
                
                <div>
                    <label pButton type="button" [label]="'SigvLibrary.Upload' | translate" icon="pi pi-cust-upload"
                        class="p-button-action p-button-outlined p-content-button p-mt-2">
                        <input type="file" style="display: none" accept=".jpg, .jpeg, .png, .pdf" #uploadSignatureInput
                            (change)="selectedUploadSignatureFile($event.target, record.name)" />
                    </label>
                    <label pButton type="button" [label]="'Common.Button.TakePhoto' | translate " icon="pi pi-camera"
                        class="p-button-action p-button-outlined p-content-button p-mt-2" [hidden]="!needWebcam">
                        <input type="button" style="display: none" accept=".jpg, .jpeg, .png, .pdf"
                            (click)="startCamera(record.name, videoElement, canvas)" />
                    </label>


                    <div [hidden]="!record.showCam">
                        <label pButton type="button" [label]="'Common.Button.CapturePhoto' | translate "
                            icon="pi pi-sync" class="p-button-action p-button-outlined p-content-button p-mt-2"
                            [hidden]="!needWebcam">
                            <input type="button" style="display: none" accept=".jpg, .jpeg, .png, .pdf"
                                (click)="capturePhoto(record.name, videoElement, canvas)" />
                        </label>

                        <label pButton type="button" [label]="'Common.Button.SwitchCamera' | translate "
                            icon="pi pi-sync" class="p-button-action p-button-outlined p-content-button p-mt-2"
                            [hidden]="!needWebcam">
                            <input type="button" style="display: none" accept=".jpg, .jpeg, .png, .pdf"
                                (click)="switchCamera(record.name, videoElement)" />
                        </label>
                        <video #videoElement autoplay [width]="videoWidth" [height]="videoHeight" playsinline></video>
                        <canvas #canvas [width]="videoWidth" [height]="videoHeight" style="display:none;"></canvas>
                    </div>
                    <div [hidden]="!record.camErr">
                      <label style="color: red;">Can't find your camera!</label>
                    </div>


                </div>
                <div *ngIf="!record.type.includes('pdf')">
                    <img title="{{ record.title | translate }}" *ngIf="record.img" class="p-mt-2 previewImg"
                        [src]="record.src" />
                </div>
                <div class="pdf-grid" *ngIf="record.type.includes('pdf')">
                    <div class="pdf-item">
                        <pdf-viewer
                        [src]="record.pdfViewString"
                        [original-size]="false"
                        style="width: 100%; height: 100vh"
                        (after-load-complete)="onPdfLoaded($event)"
                        >
                        </pdf-viewer>
                    </div>
                </div>
                
                <span class="p-text-secondary p-mt-4">{{
                    "Common.Validate.OCRUploadMessage" | translate
                    }}</span>
            </li>
        </ul>
    </div>
</p-dialog>